import React, { PureComponent } from "react";
import { Link } from "react-router";
import CollapseImage from "../containers/assets/icon_collapse.svg";
import HawkImage from "../containers/assets/hawk.png";
import FontAwesome from "react-fontawesome";
import { detectMobile } from "../services/utils";

class EconomicAnalysis extends PureComponent {
  constructor(props) {
    super(props);

    this.isMobile = detectMobile();
  }

  render() {
    const style1 = this.isMobile
      ? {
          borderSpacing: 0
        }
      : {};
    const style2 = this.isMobile
      ? {
          width: "100%",
          margin: 0
        }
      : {};

    return (
      <section className="analysis bg-gray">
        <h3 className="h3-icon semibold">
          Economic Analysis
          <FontAwesome className="question-mark" name="question-circle" />
          <Link to="/ceo/analysis" className="icon-zoom">
            <img src={CollapseImage} className="icon" alt="CollapseImage" />
          </Link>
        </h3>
        <div className="columns" style={style1}>
          <div className="column-2" style={style2}>
            <div className="row fix-after">
              {this.isMobile === false && (
                <div className="col-xs-4 p-0">
                  <div className="image hawk ml-15">
                    <img src={HawkImage} alt="Hawk" />
                  </div>
                </div>
              )}
              <div className={this.isMobile ? "col-xs-12" : "col-xs-8"}>
                <div className="panel-dashboard-white bg-light-gray pb-15">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>
                            <span />
                          </th>
                          <th>
                            <span className="color-blue">U.S.</span>
                          </th>
                          <th>
                            <span>Europe</span>
                          </th>
                          <th>
                            <span>Asia</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-center">
                          <th>Interest Rates</th>
                          <td>n/a</td>
                          <td>n/a</td>
                          <td>n/a</td>
                        </tr>
                        <tr className="text-center">
                          <th>Exchange Rates</th>
                          <td>n/a</td>
                          <td>n/a</td>
                          <td>n/a</td>
                        </tr>
                        <tr className="text-center">
                          <th>Inflation Rates</th>
                          <td>n/a</td>
                          <td>n/a</td>
                          <td>n/a</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.isMobile === false && (
            <div className="column-2">
              <p className="mb-15">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud exercitation ullamco laboris
                nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor
                in reprehenderit in voluptate velit esse cillum dolore eu fugiat
                nulla pariatur. Excepteur sint occaecat cupidatat non proident,
                sunt in culpa qui officia deserunt mollit anim id est laborum.
              </p>
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default EconomicAnalysis;



// WEBPACK FOOTER //
// ./src/containers/economic-analysis.js